export default "__VITE_ASSET__BwtF004h__"